/* LaBe Reviews — eigenes Bewertungs-Widget (Loox-Aufbau). Daten: shop-app auf Railway.
   Einbau: <div class="lr" data-lr data-shop="…myshopify.com" data-handle="…" data-title="…" data-image="…"></div>
   Sterne-Abzeichen: <a class="lr-badge" data-lr-badge data-shop data-handle href="#reviews"></a> */
(function () {
  if (window.LabeReviews) return;
  var API = 'https://labe-app-production.up.railway.app';
  var LANG = (document.documentElement.lang || 'en').slice(0, 2) === 'de' ? 'de' : 'en';
  var T = {
    en: {
      reviews: 'reviews', review: 'review', based: 'Based on', write: 'Write a review', none: 'No reviews yet',
      first: 'Be the first to share your experience.', more: 'Show more reviews', verified: 'Verified',
      sort_featured: 'Featured', sort_recent: 'Most recent', sort_highest: 'Highest rating', sort_lowest: 'Lowest rating',
      photos: 'Photos & videos', all: 'All', reply: 'Reply from', close: 'Close',
      q1: 'How would you rate this item?', labels: ['Hate it', "Don't like it", "It's OK", 'Like it', 'Love it!'],
      q2: 'Show it off', q2s: "We'd love to see it in action!", add: 'Add photos', skip: 'Skip', next: 'Next', back: 'Back',
      q3: 'Tell us more!', q3p: 'Share your experience', q4: 'About you', fn: 'First name', ln: 'Last name', em: 'Email',
      emh: 'We use it to confirm your purchase. Never shown publicly.',
      legal: 'By submitting, I acknowledge that my review, first name and last initial will be publicly posted.',
      done: 'Done', sending: 'Sending…', thanks: 'Thank you!', thx_pub: 'Your review is live.',
      thx_pend: 'Your review was submitted and will appear after a quick check.', err: 'Something went wrong. Please try again.',
      read: 'Read more', product: 'Reviewed product', loading: 'Loading…', retry: 'Try again',
      loadErr: "Reviews couldn't be loaded.", slow: 'This is taking too long. Please check your connection and try again.'
    },
    de: {
      reviews: 'Bewertungen', review: 'Bewertung', based: 'Basierend auf', write: 'Bewertung schreiben', none: 'Noch keine Bewertungen',
      first: 'Teile als Erste:r deine Erfahrung.', more: 'Mehr Bewertungen anzeigen', verified: 'Verifiziert',
      sort_featured: 'Empfohlen', sort_recent: 'Neueste', sort_highest: 'Beste zuerst', sort_lowest: 'Schlechteste zuerst',
      photos: 'Fotos & Videos', all: 'Alle', reply: 'Antwort von', close: 'Schließen',
      q1: 'Wie gefällt dir das Produkt?', labels: ['Gar nicht', 'Eher nicht', 'Okay', 'Gut', 'Super!'],
      q2: 'Zeig es uns', q2s: 'Wir freuen uns über ein Foto!', add: 'Fotos hinzufügen', skip: 'Überspringen', next: 'Weiter', back: 'Zurück',
      q3: 'Erzähl mehr!', q3p: 'Deine Erfahrung', q4: 'Über dich', fn: 'Vorname', ln: 'Nachname', em: 'E-Mail',
      emh: 'Damit bestätigen wir deinen Kauf. Wird nie angezeigt.',
      legal: 'Mit dem Absenden stimme ich zu, dass meine Bewertung mit Vorname und Initial öffentlich angezeigt wird.',
      done: 'Absenden', sending: 'Wird gesendet…', thanks: 'Danke!', thx_pub: 'Deine Bewertung ist online.',
      thx_pend: 'Deine Bewertung ist angekommen und erscheint nach einer kurzen Prüfung.', err: 'Das hat nicht geklappt. Bitte versuch es noch einmal.',
      read: 'Weiterlesen', product: 'Bewertetes Produkt', loading: 'Lädt…', retry: 'Nochmal versuchen',
      loadErr: 'Bewertungen konnten nicht geladen werden.', slow: 'Das dauert zu lange. Bitte Verbindung prüfen und nochmal versuchen.'
    }
  }[LANG];

  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.6l2.9 6 6.5.9-4.7 4.6 1.1 6.5L12 17.5l-5.8 3.1 1.1-6.5L2.6 9.5l6.5-.9z"/></svg>';
  var CHECK = '<svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="8"/><path d="M4.6 8.3l2.2 2.2 4.6-4.8" fill="none" stroke="#fff" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var CHEV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CAM = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 8h3l1.6-2.2h6.8L17 8h3v11H4z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="12" cy="13.3" r="3.4" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';

  var PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>';
  // Produktschild je Bewertung (Bild + Name), Daten aus /products/<handle>.js derselben Seite
  var PROD = {}, PROD_WAIT = {};
  function shortTitle(t) { return String(t || '').split(' — ')[0].replace(/\s*\(add-on\)\s*/i, '').trim(); }
  function prodTag(r, big) {
    var h = r.product && r.product.handle; if (!h) return '';
    var info = PROD[h], name = shortTitle((info && info.title) || r.product.title || h);
    var th = info && info.img ? '<img src="' + esc(img(info.img, big ? 160 : 90)) + '" alt="" loading="lazy">' : '<span class="lr-prod-ph"></span>';
    var link = !/add-on/.test(h);
    return (link ? '<a class="lr-prod' + (big ? ' lr-prod-lg' : '') + '" href="/products/' + esc(h) + '"' : '<span class="lr-prod' + (big ? ' lr-prod-lg' : '') + '"') +
      ' data-lr-prod="' + esc(h) + '">' + th + '<span>' + esc(name) + '</span>' + (link ? '</a>' : '</span>');
  }
  function loadProducts(handles) {
    handles.forEach(function (h) {
      if (!h || PROD[h] || PROD_WAIT[h]) return; PROD_WAIT[h] = 1;
      fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return;
        var im = p.featured_image || (p.images && p.images[0]) || '';
        PROD[h] = { title: p.title, img: im ? (im.indexOf('//') === 0 ? 'https:' + im : im) : '' };
        document.querySelectorAll('[data-lr-prod="' + h + '"]').forEach(function (el) {
          var big = el.classList.contains('lr-prod-lg'), tmp = document.createElement('div');
          tmp.innerHTML = prodTag({ product: { handle: h, title: p.title } }, big); el.replaceWith(tmp.firstChild);
        });
      }).catch(function () {});
    });
  }
  function mediaThumb(m, w) {
    var poster = m.type === 'video' ? (m.poster || '') : m.url;
    return (poster ? '<img src="' + esc(img(poster, w)) + '" alt="' + esc(m.alt || '') + '" loading="lazy" decoding="async">'
      : '<video src="' + esc(m.url) + '#t=0.1" muted playsinline preload="metadata"></video>') + (m.type === 'video' ? '<span class="lr-play">' + PLAY + '</span>' : '');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function stars(n, cls) {
    var h = '<span class="lr-stars ' + (cls || '') + '" role="img" aria-label="' + (Math.round(n * 10) / 10) + ' / 5">';
    for (var i = 1; i <= 5; i++) {
      var f = Math.max(0, Math.min(1, n - i + 1));
      h += '<span class="lr-star"><span class="lr-star-bg">' + STAR + '</span><span class="lr-star-fg" style="width:' + Math.round(f * 100) + '%">' + STAR + '</span></span>';
    }
    return h + '</span>';
  }
  function fmtDate(d) {
    try { return new Date(d).toLocaleDateString(LANG === 'de' ? 'de-DE' : 'en-US', { month: 'short', day: 'numeric', year: 'numeric' }); } catch (e) { return ''; }
  }
  function img(url, w) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  // fetch mit Zeitlimit: hängt nie endlos (Server kalt, Funkloch …)
  function fetchT(url, opts, ms) {
    var ctl = window.AbortController ? new AbortController() : null, tm;
    opts = opts || {}; if (ctl) opts.signal = ctl.signal;
    return Promise.race([
      fetch(url, opts),
      new Promise(function (_, rej) { tm = setTimeout(function () { if (ctl) ctl.abort(); var e = new Error(T.slow); e.timeout = true; rej(e); }, ms); })
    ]).then(function (r) { clearTimeout(tm); return r; }, function (e) { clearTimeout(tm); throw e; });
  }
  function get(shop, params) {
    var q = Object.keys(params).map(function (k) { return k + '=' + encodeURIComponent(params[k]); }).join('&');
    return fetchT(API + '/api/reviews?shop=' + encodeURIComponent(shop) + '&' + q, {}, 15000).then(function (r) { return r.json(); });
  }
  var lockY = 0;
  function lock(on) {
    if (on) { lockY = window.scrollY; document.documentElement.classList.add('lr-locked'); }
    else { document.documentElement.classList.remove('lr-locked'); }
  }

  /* ── Widget ─────────────────────────────────────────────────────── */
  function Widget(el) {
    this.el = el; this.shop = el.dataset.shop; this.handle = el.dataset.handle;
    this.title = el.dataset.title || ''; this.image = el.dataset.image || '';
    this.showProducts = el.dataset.products === '1'; // Schild „für welches Produkt“ (geteilter Pool über mehrere Produkte)
    this.limit = Number(el.dataset.limit) || (window.innerWidth < 760 ? 6 : 12); // Handy: erst 6 Karten, dann „Mehr“
    this.state = { page: 1, sort: 'featured', photos: false, items: [], pages: 1, summary: null };
    this.seq = 0;
    this.el.classList.add('lr');
    this.el.innerHTML = '<div class="lr-loading"><span></span><span></span><span></span></div>';
    this.bind();
    this.load(true);
  }
  // Nur die jeweils letzte Anfrage zählt (schnelles Klicken auf Filter/Sortierung/Mehr bringt sonst Antworten durcheinander)
  Widget.prototype.load = function (reset) {
    var self = this, s = this.state, seq = ++this.seq, page = reset ? 1 : s.page + 1;
    var p = { handle: this.handle, page: page, sort: s.sort, limit: this.limit };
    if (s.photos) p.photos = 1;
    if (s.summary) this.el.classList.add('is-loading');
    var more = this.el.querySelector('[data-act=more]'); if (more && !reset) { more.disabled = true; more.textContent = T.loading; }
    return get(this.shop, p).then(function (d) {
      if (seq !== self.seq) return;
      if (!d || d.error || !d.summary) throw new Error(d && d.error);
      var base = reset ? [] : s.items, seen = {};
      base.forEach(function (r) { seen[r.id] = 1; });
      s.items = base.concat((d.reviews || []).filter(function (r) { return !seen[r.id]; }));
      s.summary = d.summary; s.pages = d.pages; s.page = page;
      self.el.classList.remove('is-loading', 'lr-off');
      self.render();
      if (self.showProducts) loadProducts(s.items.map(function (r) { return r.product && r.product.handle; }));
      updateBadges(self.shop, self.handle, d.summary);
    }).catch(function (e) {
      if (seq !== self.seq) return;
      self.el.classList.remove('is-loading');
      if (!s.summary) {
        self.el.innerHTML = '<div class="lr-err">' + T.loadErr + ' <button type="button" class="lr-btn lr-btn-ghost" data-act="retry">' + T.retry + '</button></div>';
      } else { self.render(); self.note(e && e.timeout ? T.slow : T.err); }
    });
  };
  Widget.prototype.note = function (msg) {
    var n = document.createElement('div'); n.className = 'lr-note'; n.setAttribute('role', 'status'); n.textContent = msg;
    this.el.appendChild(n); setTimeout(function () { n.remove(); }, 4500);
  };
  // Klicks + Tastatur einmal am Container (überlebt jedes Neuzeichnen)
  Widget.prototype.bind = function () {
    var self = this, s = this.state;
    this.el.addEventListener('click', function (e) {
      if (e.target.closest('a.lr-prod')) return; // Produktschild = normaler Link
      var t = e.target.closest('[data-act]'); if (!t || !self.el.contains(t) || t.disabled) return;
      var a = t.dataset.act;
      if (a === 'write') openWrite(self);
      else if (a === 'more') self.load(false);
      else if (a === 'retry') { self.el.innerHTML = '<div class="lr-loading"><span></span><span></span><span></span></div>'; self.load(true); }
      else if (a === 'all') { if (s.photos) { s.photos = false; self.load(true); } }
      else if (a === 'photos') { if (!s.photos) { s.photos = true; self.load(true); } }
      else if (a === 'open') openDetail(self, Number(t.dataset.i));
    });
    this.el.addEventListener('keydown', function (e) {
      var c = e.target.closest && e.target.closest('.lr-card');
      if (c && e.target === c && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); openDetail(self, Number(c.dataset.i)); }
    });
    this.el.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('select[data-act="sort"]')) { s.sort = e.target.value; self.load(true); }
    });
  };
  Widget.prototype.render = function () {
    var self = this, s = this.state, sm = s.summary || { avg: 0, count: 0, dist: {} };
    var head;
    if (!sm.count) {
      head = '<div class="lr-head lr-head-empty"><div class="lr-head-main">' + stars(0, 'lr-stars-lg') +
        '<div class="lr-empty-t">' + T.none + '</div><div class="lr-empty-s">' + T.first + '</div></div>' +
        '<button type="button" class="lr-btn" data-act="write">' + T.write + '</button></div>';
      this.el.innerHTML = head;
    } else {
      var bars = '';
      for (var i = 5; i >= 1; i--) {
        var n = sm.dist[i] || 0, pct = sm.count ? Math.round(n / sm.count * 100) : 0;
        bars += '<div class="lr-bar"><span class="lr-bar-l">' + i + STAR + '</span><span class="lr-bar-t"><span style="width:' + pct + '%"></span></span><span class="lr-bar-n">' + n + '</span></div>';
      }
      head = '<div class="lr-head">' +
        '<div class="lr-head-main"><div class="lr-avg">' + sm.avg.toFixed(1) + '</div><div>' + stars(sm.avg, 'lr-stars-lg') +
        '<div class="lr-based">' + T.based + ' ' + sm.count + ' ' + (sm.count === 1 ? T.review : T.reviews) + '</div></div></div>' +
        '<div class="lr-bars">' + bars + '</div>' +
        '<button type="button" class="lr-btn" data-act="write">' + T.write + '</button></div>' +
        '<div class="lr-tools"><div class="lr-chips">' +
        '<button type="button" class="lr-chip' + (!s.photos ? ' is-on' : '') + '" data-act="all">' + T.all + ' <b>' + sm.count + '</b></button>' +
        (sm.photos ? '<button type="button" class="lr-chip' + (s.photos ? ' is-on' : '') + '" data-act="photos">' + CAM + T.photos + ' <b>' + sm.photos + '</b></button>' : '') +
        '</div><label class="lr-sort"><select data-act="sort" aria-label="Sort">' +
        ['featured', 'recent', 'highest', 'lowest'].map(function (k) { return '<option value="' + k + '"' + (s.sort === k ? ' selected' : '') + '>' + T['sort_' + k] + '</option>'; }).join('') +
        '</select></label></div>';
      var cards = s.items.map(function (r, idx) { return self.card(r, idx); }).join('');
      this.el.innerHTML = head + '<div class="lr-grid">' + cards + '</div>' +
        (s.page < s.pages ? '<div class="lr-more-wrap"><button type="button" class="lr-btn lr-btn-ghost" data-act="more">' + T.more + '</button></div>' : '');
    }
  };
  Widget.prototype.card = function (r, i) {
    var m = r.media && r.media[0];
    var ph = m ? '<div class="lr-card-img" style="aspect-ratio:' + (m.w && m.h ? Math.max(0.6, Math.min(1.6, m.w / m.h)) : 0.8) + '">' + mediaThumb(m, 600) + (r.media.length > 1 ? '<span class="lr-card-n">+' + (r.media.length - 1) + '</span>' : '') + '</div>' : '';
    return '<article class="lr-card' + (m ? ' has-img' : '') + '" data-act="open" data-i="' + i + '" tabindex="0" role="button" aria-label="' + esc(r.author) + ', ' + r.rating + ' / 5">' + ph +
      '<div class="lr-card-b"><div class="lr-card-top"><span class="lr-name">' + esc(r.author) + '</span>' +
      (r.verified ? '<span class="lr-ver" title="' + T.verified + '">' + CHECK + '</span>' : '') + '</div>' +
      stars(r.rating) +
      (r.title ? '<div class="lr-card-title">' + esc(r.title) + '</div>' : '') +
      '<p class="lr-text">' + esc(r.body) + '</p>' +
      (r.reply ? '<div class="lr-reply"><b>' + T.reply + ' ' + esc(shopName()) + '</b>' + esc(r.reply) + '</div>' : '') +
      '<div class="lr-date">' + fmtDate(r.date) + '</div>' + (this.showProducts ? prodTag(r) : '') + '</div></article>';
  };
  function shopName() { return (window.LabeReviewsShopName || document.title.split(/[–|—-]/).pop() || '').trim(); }

  /* ── Detail-Fenster ─────────────────────────────────────────────── */
  function modal(cls, html, w, onKey) {
    var prevFocus = document.activeElement, closed = false;
    var o = document.createElement('div');
    o.className = 'lr-ov ' + cls + (w && w.el.dataset.lrTheme === 'dark' ? ' lr-dark' : '');
    if (w) {
      // Farben + Schrift des Widgets übernehmen (das Fenster hängt am <body>, außerhalb der Seiten-Variablen)
      var cs = getComputedStyle(w.el);
      ['--lr-star', '--lr-star-off', '--lr-text', '--lr-muted', '--lr-card', '--lr-line', '--lr-bg', '--lr-accent', '--lr-accent-text', '--lr-chip', '--lr-ver', '--lr-radius']
        .forEach(function (k) { var v = cs.getPropertyValue(k).trim(); if (v) o.style.setProperty(k, v); });
      o.style.fontFamily = cs.fontFamily;
    }
    o.setAttribute('role', 'dialog'); o.setAttribute('aria-modal', 'true');
    o.innerHTML = '<div class="lr-modal">' + html + '</div>';
    (document.querySelector('.lr-scope') || document.body).appendChild(o);
    lock(true);
    requestAnimationFrame(function () { o.classList.add('is-open'); var x = o.querySelector('.lr-x'); if (x) try { x.focus({ preventScroll: true }); } catch (e) {} });
    function close() {
      if (closed) return; closed = true;
      o.classList.remove('is-open'); lock(false); document.removeEventListener('keydown', key);
      o.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) {} });
      setTimeout(function () { o.remove(); }, 220);
      if (o._onClose) o._onClose();
      if (prevFocus && prevFocus.focus) try { prevFocus.focus({ preventScroll: true }); } catch (e) {}
    }
    function key(e) { if (e.key === 'Escape') close(); else if (onKey) onKey(e); }
    document.addEventListener('keydown', key);
    o.addEventListener('click', function (e) { if (e.target === o || e.target.closest('[data-close]')) close(); });
    o._close = close;
    return o;
  }
  function openDetail(w, i) {
    var items = w.state.items, o;
    function html(r) {
      var media = r.media || [];
      var gal = media.length ? '<div class="lr-d-media"><div class="lr-d-track">' + media.map(function (m) {
        return m.type === 'video' ? '<video src="' + esc(m.url) + '"' + (m.poster ? ' poster="' + esc(img(m.poster, 1200)) + '"' : '') + ' controls playsinline preload="metadata"></video>'
          : '<img src="' + esc(img(m.url, 1200)) + '" alt="' + esc(m.alt || '') + '">';
      }).join('') + '</div>' + (media.length > 1 ? '<div class="lr-d-dots">' + media.map(function (_, k) { return '<span' + (k ? '' : ' class="is-on"') + '></span>'; }).join('') + '</div>' : '') + '</div>' : '';
      return '<button type="button" class="lr-x" data-close aria-label="' + T.close + '">' + X + '</button>' +
        '<div class="lr-d' + (media.length ? ' has-img' : '') + '">' + gal + '<div class="lr-d-b">' +
        '<div class="lr-card-top"><span class="lr-name">' + esc(r.author) + '</span>' + (r.verified ? '<span class="lr-ver-t">' + CHECK + T.verified + '</span>' : '') + '</div>' +
        stars(r.rating) + '<div class="lr-date">' + fmtDate(r.date) + (r.country ? ' · ' + esc(r.country) : '') + '</div>' +
        (r.title ? '<div class="lr-card-title">' + esc(r.title) + '</div>' : '') +
        '<p class="lr-d-text">' + esc(r.body) + '</p>' +
        (r.reply ? '<div class="lr-reply"><b>' + T.reply + ' ' + esc(shopName()) + '</b>' + esc(r.reply) + '</div>' : '') +
        (r.product && r.product.handle ? '<div class="lr-d-prod"><div class="lr-d-prod-l">' + T.product + '</div>' + prodTag(r, true) + '</div>' : '') +
        '</div></div>' +
        (items.length > 1 ? '<button type="button" class="lr-nav lr-prev" data-nav="-1" aria-label="Previous">' + CHEV + '</button><button type="button" class="lr-nav lr-next" data-nav="1" aria-label="Next">' + CHEV + '</button>' : '');
    }
    function go(dir) { if (items.length < 2) return; i = (i + dir + items.length) % items.length; box.innerHTML = html(items[i]); wire(); var x = box.querySelector('.lr-x'); if (x) try { x.focus({ preventScroll: true }); } catch (e) {} }
    o = modal('lr-ov-detail', html(items[i]), w, function (e) { if (e.key === 'ArrowRight') go(1); else if (e.key === 'ArrowLeft') go(-1); });
    var box = o.querySelector('.lr-modal');
    function wire() {
      var fv = box.querySelector('.lr-d-track video'); if (fv) { try { fv.play()['catch'](function () {}); } catch (e) {} }
      var cur = items[i]; if (cur && cur.product) loadProducts([cur.product.handle]);
      var tr = box.querySelector('.lr-d-track'), dots = box.querySelectorAll('.lr-d-dots span');
      if (tr && dots.length) tr.addEventListener('scroll', function () {
        var k = Math.round(tr.scrollLeft / tr.clientWidth);
        dots.forEach(function (d, j) { d.classList.toggle('is-on', j === k); });
      }, { passive: true });
    }
    wire();
    box.addEventListener('click', function (e) {
      var n = e.target.closest('[data-nav]'); if (!n) return;
      go(Number(n.dataset.nav));
    });
  }

  /* ── Bewertung schreiben (4 Schritte wie Loox) ─────────────────── */
  function downscale(file) {
    return new Promise(function (res) {
      if (!/^image\/(jpeg|png|webp)$/.test(file.type) || file.size < 1.5e6) return res(file);
      var im = new Image(), url = URL.createObjectURL(file);
      im.onload = function () {
        var k = Math.min(1, 2000 / Math.max(im.width, im.height)), c = document.createElement('canvas');
        c.width = Math.round(im.width * k); c.height = Math.round(im.height * k);
        c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
        c.toBlob(function (b) { URL.revokeObjectURL(url); res(b ? new File([b], (file.name || 'photo').replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' }) : file); }, 'image/jpeg', 0.86);
      };
      im.onerror = function () { URL.revokeObjectURL(url); res(file); };
      im.src = url;
    });
  }
  function openWrite(w) {
    var st = { step: 1, rating: 0, files: [] }, starTimer = null, sending = false;
    function thumbUrl(f) { if (!f._u) f._u = URL.createObjectURL(f); return f._u; }
    var o = modal('lr-ov-write', '<button type="button" class="lr-x" data-close aria-label="' + T.close + '">' + X + '</button><div class="lr-w"></div>', w);
    o._onClose = function () { clearTimeout(starTimer); st.files.forEach(function (f) { if (f._u) URL.revokeObjectURL(f._u); }); };
    var box = o.querySelector('.lr-w');
    function prog() { return '<div class="lr-w-prog">' + [1, 2, 3, 4].map(function (k) { return '<span class="' + (k <= st.step ? 'is-on' : '') + '"></span>'; }).join('') + '</div>'; }
    function prod() { return w.image ? '<img class="lr-w-prod" src="' + esc(img(w.image, 240)) + '" alt="">' : ''; }
    function draw() {
      var h = '';
      if (st.step === 1) {
        h = prog() + prod() + '<h3>' + T.q1 + '</h3><div class="lr-w-stars" role="radiogroup">' +
          [1, 2, 3, 4, 5].map(function (k) { return '<button type="button" role="radio" aria-checked="' + (st.rating === k) + '" data-r="' + k + '" class="' + (k <= st.rating ? 'is-on' : '') + '" aria-label="' + k + ' – ' + T.labels[k - 1] + '">' + STAR + '</button>'; }).join('') +
          '</div><div class="lr-w-lab">' + (st.rating ? T.labels[st.rating - 1] : '&nbsp;') + '</div>';
      } else if (st.step === 2) {
        h = prog() + '<h3>' + T.q2 + '</h3><p class="lr-w-sub">' + T.q2s + '</p>' +
          '<div class="lr-w-thumbs">' + st.files.map(function (f, k) { return '<span class="lr-w-th"><img src="' + thumbUrl(f) + '" alt=""><button type="button" data-rm="' + k + '" aria-label="Remove">' + X + '</button></span>'; }).join('') + '</div>' +
          (st.files.length < 3 ? '<label class="lr-btn lr-w-add">' + CAM + T.add + '<input type="file" accept="image/*" multiple hidden></label>' : '') +
          '<div class="lr-w-row"><button type="button" class="lr-link" data-go="1">' + T.back + '</button><button type="button" class="lr-btn" data-go="3">' + (st.files.length ? T.next : T.skip) + '</button></div>';
      } else if (st.step === 3) {
        h = prog() + '<h3>' + T.q3 + '</h3><textarea class="lr-in lr-w-ta" maxlength="4000" placeholder="' + T.q3p + '">' + esc(st.body || '') + '</textarea>' +
          '<div class="lr-w-row"><button type="button" class="lr-link" data-go="2">' + T.back + '</button><button type="button" class="lr-btn" data-go="4">' + T.next + '</button></div>';
      } else if (st.step === 4) {
        h = prog() + '<h3>' + T.q4 + '</h3><form class="lr-w-form" novalidate>' +
          '<div class="lr-w-2"><input class="lr-in" name="first_name" autocomplete="given-name" placeholder="' + T.fn + ' *" required value="' + esc(st.fn || '') + '"><input class="lr-in" name="last_name" autocomplete="family-name" placeholder="' + T.ln + '" value="' + esc(st.ln || '') + '"></div>' +
          '<input class="lr-in" type="email" name="email" autocomplete="email" placeholder="' + T.em + ' *" required value="' + esc(st.em || '') + '"><div class="lr-w-hint">' + T.emh + '</div>' +
          '<input type="text" name="website" tabindex="-1" autocomplete="off" class="lr-hp" aria-hidden="true">' +
          '<p class="lr-w-legal">' + T.legal + '</p><div class="lr-w-err" role="alert"></div>' +
          '<div class="lr-w-row"><button type="button" class="lr-link" data-go="3">' + T.back + '</button><button type="submit" class="lr-btn">' + T.done + '</button></div></form>';
      } else {
        h = '<div class="lr-w-done">' + stars(st.rating, 'lr-stars-lg') + '<h3>' + T.thanks + '</h3><p class="lr-w-sub">' + (st.status === 'published' ? T.thx_pub : T.thx_pend) + '</p><button type="button" class="lr-btn" data-close>' + T.close + '</button></div>';
      }
      box.innerHTML = h;
      var ta = box.querySelector('.lr-w-ta'); if (ta) { ta.focus(); ta.oninput = function () { st.body = ta.value; }; }
      var fi = box.querySelector('input[type=file]');
      if (fi) fi.onchange = function () {
        var add = Array.prototype.slice.call(fi.files).filter(function (f) { return /^image\//.test(f.type) || /\.(heic|heif|jpe?g|png|webp)$/i.test(f.name || ''); }).slice(0, 3 - st.files.length);
        fi.value = '';
        Promise.all(add.map(downscale)).then(function (fs) { st.files = st.files.concat(fs).slice(0, 3); draw(); });
      };
      var form = box.querySelector('.lr-w-form');
      if (form) {
        ['first_name', 'last_name', 'email'].forEach(function (n, k) { form[n].oninput = function () { st[['fn', 'ln', 'em'][k]] = form[n].value; }; });
        form.onsubmit = function (e) { e.preventDefault(); submit(form); };
      }
    }
    function submit(form) {
      var err = box.querySelector('.lr-w-err'), btn = form.querySelector('[type=submit]');
      if (!form.first_name.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.value.trim())) { err.textContent = LANG === 'de' ? 'Bitte Vorname und gültige E-Mail angeben.' : 'Please enter your first name and a valid email.'; return; }
      var fd = new FormData();
      fd.append('shop', w.shop); fd.append('handle', w.handle); fd.append('product_title', w.title);
      fd.append('rating', st.rating); fd.append('body', st.body || ''); fd.append('locale', LANG);
      ['first_name', 'last_name', 'email', 'website'].forEach(function (n) { fd.append(n, form[n].value.trim()); });
      st.files.forEach(function (f) { fd.append('photos', f, f.name || 'photo.jpg'); });
      if (sending) return; sending = true;
      btn.disabled = true; btn.textContent = T.sending; err.textContent = '';
      fetchT(API + '/api/reviews?shop=' + encodeURIComponent(w.shop), { method: 'POST', body: fd }, 60000)
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (x) {
          if (!x.ok || !x.d.ok) throw new Error((x.d && x.d.error) || T.err);
          st.status = x.d.status; st.step = 5; draw();
          if (x.d.status === 'published') w.load(true);
        })
        .catch(function (e) { sending = false; err.textContent = (e && e.message && !/fetch|network|abort/i.test(e.message)) ? e.message : T.err; btn.disabled = false; btn.textContent = T.done; });
    }
    box.addEventListener('click', function (e) {
      var r = e.target.closest('[data-r]');
      if (r) { st.rating = Number(r.dataset.r); draw(); clearTimeout(starTimer); starTimer = setTimeout(function () { if (st.step === 1) { st.step = 2; draw(); } }, 280); return; }
      var rm = e.target.closest('[data-rm]');
      if (rm) { var gone = st.files.splice(Number(rm.dataset.rm), 1)[0]; if (gone && gone._u) URL.revokeObjectURL(gone._u); draw(); return; }
      var g = e.target.closest('[data-go]');
      if (g) {
        var to = Number(g.dataset.go);
        if (to === 4 && (st.body || '').trim().length < 2) { var ta = box.querySelector('.lr-w-ta'); if (ta) { ta.classList.add('is-bad'); ta.focus(); } return; }
        st.step = to; draw();
      }
    });
    draw();
  }

  /* ── Sterne-Abzeichen (unter Produkttitel, auf Karten) ─────────── */
  function badgeHTML(sm) {
    if (!sm || !sm.count) return '';
    return stars(sm.avg) + '<span class="lr-badge-t">' + sm.avg.toFixed(1) + ' · ' + sm.count + ' ' + (sm.count === 1 ? T.review : T.reviews) + '</span>';
  }
  function updateBadges(shop, handle, sm) {
    document.querySelectorAll('[data-lr-badge][data-handle="' + handle + '"]').forEach(function (b) {
      if (b.dataset.ssr === '1' && b.innerHTML.trim()) return;
      b.innerHTML = badgeHTML(sm); b.classList.toggle('is-empty', !sm.count);
    });
  }
  function initBadges() {
    var need = {};
    document.querySelectorAll('[data-lr-badge]').forEach(function (b) {
      if (b.dataset.ssr === '1' || b._lr) return; b._lr = 1;
      (need[b.dataset.shop] = need[b.dataset.shop] || {})[b.dataset.handle] = 1;
    });
    Object.keys(need).forEach(function (shop) {
      var hs = Object.keys(need[shop]);
      if (!hs.length) return;
      fetch(API + '/api/reviews/summary?shop=' + encodeURIComponent(shop) + '&handles=' + encodeURIComponent(hs.join(',')))
        .then(function (r) { return r.json(); })
        .then(function (d) { hs.forEach(function (h) { updateBadges(shop, h, d[h]); }); }).catch(function () {});
    });
    document.querySelectorAll('[data-lr-badge]').forEach(function (b) {
      if (b._lrc) return; b._lrc = 1;
      b.addEventListener('click', function (e) {
        var href = b.getAttribute('href') || '', sec = href.charAt(0) === '#' && href.length > 1 ? document.getElementById(href.slice(1)) : null;
        var t = sec || document.querySelector('[data-lr][data-handle="' + b.dataset.handle + '"]');
        if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-lr]').forEach(function (el) { if (!el._lr) { el._lr = new Widget(el); } });
    initBadges();
  }
  window.LabeReviews = { init: init, open: function (handle) { var el = document.querySelector('[data-lr][data-handle="' + handle + '"]'); if (el && el._lr) openWrite(el._lr); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
